// extracted by mini-css-extract-plugin
export default {"player":"audio-player_player__LzEQP","fullWidth":"audio-player_fullWidth__6p+d7","removeBtn":"audio-player_removeBtn__GzYM6"};